import { dscvrIcApi } from '@/shared/api';
import { useMutation } from '@tanstack/vue-query';

export const useSetUserBioMutation = () => {
  return useMutation({
    mutationKey: ['set-user-bio-mutation'],
    mutationFn: dscvrIcApi.userSettings.setUserBio,
  });
};
